(() => {
    if (window.haloAccessibleControlsLoaded) return;
    window.haloAccessibleControlsLoaded = true;
    const focusSelector = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
    const visible = element => element && !element.closest('[hidden], [inert]') && [...element.getClientRects()].some(rect => rect.width > 0 && rect.height > 0) && getComputedStyle(element).visibility !== 'hidden';
    const focusables = root => [...root.querySelectorAll(focusSelector)].filter(visible);
    const setExpanded = (button, value) => {
        if (button && button.getAttribute('aria-expanded') !== String(value)) button.setAttribute('aria-expanded', String(value));
    };
    let filterNumber = 0;
    function initializeFilters(root = document) {
        root.querySelectorAll('.halo-filter-toggle').forEach(button => {
            const block = button.closest('.sidebarBlock');
            const panel = block?.querySelector('.sidebarBlock-content--full');
            if (!panel) return;
            if (!panel.id) panel.id = `AccessibleFilter-${++filterNumber}`;
            button.setAttribute('aria-controls', panel.id);
            const horizontal = block.closest('.page-sidebar--horizontal') && window.innerWidth >= 1025;
            const heading = button.closest('.sidebarBlock-heading');
            setExpanded(button, horizontal ? block.hasAttribute('data-filter-open') || (block.matches(':hover') && !block.hasAttribute('data-filter-dismissed')) : panel.classList.contains('sidebarBlock-slide__content') ? panel.classList.contains('is-show') : heading.classList.contains('is-clicked'));
        });
    }
    function initializeVertical(root = document) {
        root.querySelectorAll('.vertical-menu').forEach(menu => {
            const button = menu.querySelector('[data-vertical-toggle]');
            if (!button || menu.accessibleObserver) return;
            const sync = () => setExpanded(button, menu.classList.contains('vertical-menu__style_3') ? !menu.hasAttribute('data-vertical-dismissed') && (menu.hasAttribute('data-vertical-open') || menu.matches(':hover')) : !menu.classList.contains('vertical-menu__hide'));
            menu.accessibleObserver = new MutationObserver(sync);
            menu.accessibleObserver.observe(menu, {attributes: true, attributeFilter: ['class', 'data-vertical-open', 'data-vertical-dismissed']});
            menu.addEventListener('mouseenter', () => { menu.removeAttribute('data-vertical-dismissed'); sync(); });
            menu.addEventListener('mouseleave', sync);
            sync();
        });
    }
    function closeVertical(menu) {
        if (!menu.classList.contains('vertical-menu__style_3')) {
            menu.classList.add('vertical-menu__hide');
            menu.classList.remove('vertical-menu__open');
        }
        menu.removeAttribute('data-vertical-open');
        menu.setAttribute('data-vertical-dismissed', '');
        menu.querySelector('[data-vertical-toggle]')?.focus();
        document.getElementById('menu-overlay')?.classList.remove('is-visible');
    }
    function initialize(root = document) {
        initializeFilters(root);
        initializeVertical(root);
    }
    initialize();
    document.addEventListener('shopify:section:load', event => initialize(event.target));
    document.addEventListener('click', event => {
        const verticalButton = event.target.closest('[data-vertical-toggle]');
        if (verticalButton) {
            const menu = verticalButton.closest('.vertical-menu');
            menu.removeAttribute('data-vertical-dismissed');
            if (menu.classList.contains('vertical-menu__style_3')) {
                const open = !menu.hasAttribute('data-vertical-open');
                menu.toggleAttribute('data-vertical-open', open);
                menu.toggleAttribute('data-vertical-dismissed', !open);
            }
        }
        const button = event.target.closest('.halo-filter-toggle');
        if (button) {
            initializeFilters(button.closest('.page-sidebar'));
            const block = button.closest('.sidebarBlock');
            if (block.closest('.page-sidebar--horizontal') && window.innerWidth >= 1025) {
                event.preventDefault();
                event.stopPropagation();
                const open = !block.hasAttribute('data-filter-open');
                block.toggleAttribute('data-filter-open', open);
                block.toggleAttribute('data-filter-dismissed', !open);
                setExpanded(button, open);
            } else requestAnimationFrame(() => {
                initializeFilters(block);
                const slide = block.querySelector('.sidebarBlock-slide__content.is-show');
                if (slide) focusables(slide)[0]?.focus();
            });
        }
        const filterBack = event.target.closest('.sidebarBlock-slide__content-close');
        if (filterBack) requestAnimationFrame(() => {
            const block = filterBack.closest('.sidebarBlock');
            initializeFilters(block);
            block.querySelector('.halo-filter-toggle')?.focus();
        });
        const back = event.target.closest('.halo-menu-back');
        if (back) {
            const owner = back.closest('.nav-title-mobile')?.parentElement.closest('.menu-lv-item.is-open');
            const opener = owner?.querySelector(':scope > .menu_mobile_link, :scope > .site-nav-list-dropdown > .menu_mobile_link_2');
            requestAnimationFrame(() => { setExpanded(opener, false); opener?.focus(); });
        }
        const toggle = event.target.closest('.site-nav-mobile .menu_mobile_link, .site-nav-mobile .menu_mobile_link_2');
        if (toggle && !toggle.classList.contains('list-menu__item--end')) requestAnimationFrame(() => setExpanded(toggle, true));
    }, true);
    document.addEventListener('mouseover', event => {
        const block = event.target.closest('.page-sidebar--horizontal .sidebarBlock');
        if (block && !block.contains(event.relatedTarget) && window.innerWidth >= 1025) {
            block.removeAttribute('data-filter-dismissed');
            setExpanded(block.querySelector('.halo-filter-toggle'), true);
        }
        const menu = event.target.closest('.has-megamenu');
        if (menu && !menu.contains(event.relatedTarget)) menu.removeAttribute('data-keyboard-dismissed');
    });
    document.addEventListener('mouseout', event => {
        const block = event.target.closest('.page-sidebar--horizontal .sidebarBlock');
        if (block && !block.contains(event.relatedTarget) && window.innerWidth >= 1025) setExpanded(block.querySelector('.halo-filter-toggle'), block.hasAttribute('data-filter-open'));
    });
    document.addEventListener('focusout', event => {
        const menu = event.target.closest('.has-megamenu');
        if (menu && !menu.contains(event.relatedTarget)) menu.removeAttribute('data-keyboard-dismissed');
        const block = event.target.closest('.page-sidebar--horizontal .sidebarBlock');
        if (block && !block.contains(event.relatedTarget) && window.innerWidth >= 1025) {
            block.removeAttribute('data-filter-open');
            block.removeAttribute('data-filter-dismissed');
            setExpanded(block.querySelector('.halo-filter-toggle'), block.matches(':hover'));
        }
    });
    document.addEventListener('keydown', event => {
        if (event.defaultPrevented) return;
        const vertical = event.target.closest('.vertical-menu');
        const mega = event.target.closest('.has-megamenu');
        if (window.innerWidth >= 1025 && mega && !mega.hasAttribute('data-keyboard-dismissed') && event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            mega.setAttribute('data-keyboard-dismissed', '');
            mega.querySelector(':scope > a, :scope > button')?.focus();
            return;
        }
        if (window.innerWidth >= 1025 && mega && event.key === 'ArrowDown' && event.target.matches('.menu-lv-1__action')) {
            event.preventDefault();
            mega.removeAttribute('data-keyboard-dismissed');
            focusables(mega.querySelector(':scope > .menu-dropdown') || mega)[0]?.focus();
        }
        if (vertical && event.key === 'Escape') {
            event.preventDefault();
            closeVertical(vertical);
        }
        const block = event.target.closest('.page-sidebar--horizontal .sidebarBlock');
        if (block && window.innerWidth >= 1025 && event.key === 'Escape') {
            event.preventDefault();
            block.removeAttribute('data-filter-open');
            block.setAttribute('data-filter-dismissed', '');
            const button = block.querySelector('.halo-filter-toggle');
            setExpanded(button, false);
            button?.focus();
        }
    });

    const drawer = document.getElementById('halo-cart-sidebar');
    let cartOpen = false;
    let cartOpener = null;
    let lastControl = null;
    let toolOpener = null;
    let sidebarOpen = false;
    let sidebarOpener = null;
    const externalPopup = () => ['quick-view-show', 'quickshop-popup-show', 'quick_shop_popup_mobile', 'edit-cart-show', 'term-condition-show', 'has-warning'].some(name => document.body.classList.contains(name)) || [...document.querySelectorAll('[role="dialog"][aria-modal="true"]')].some(dialog => dialog !== drawer && !drawer?.contains(dialog) && visible(dialog));
    document.addEventListener('click', event => {
        const control = event.target.closest(focusSelector);
        if (control && !drawer?.contains(control)) lastControl = control;
        const sidebarButton = event.target.closest('[data-sidebar][aria-controls]');
        if (sidebarButton) sidebarOpener = sidebarButton;
        const tool = event.target.closest('.cartTool-item');
        if (tool && drawer?.contains(tool)) {
            toolOpener = tool;
            requestAnimationFrame(() => {
                const popup = drawer.querySelector('.popup-toolDown.show');
                if (popup) focusables(popup)[0]?.focus();
            });
        }
    }, true);
    const focusDrawer = () => {
        if (!drawer || externalPopup()) return;
        (focusables(drawer)[0] || drawer).focus({preventScroll: true});
    };
    function syncBody() {
        const openSidebar = document.body.classList.contains('open-mobile-sidebar');
        document.querySelectorAll('[data-sidebar][aria-controls]').forEach(button => setExpanded(button, openSidebar));
        if (openSidebar !== sidebarOpen) {
            sidebarOpen = openSidebar;
            if (sidebarOpen) {
                const sidebar = document.getElementById(sidebarOpener?.getAttribute('aria-controls') || 'halo-sidebar');
                if (sidebar) requestAnimationFrame(() => {
                    if (sidebarOpen) focusables(sidebar)[0]?.focus({preventScroll: true});
                });
            } else if (visible(sidebarOpener)) sidebarOpener.focus({preventScroll: true});
        }
        if (!drawer) return;
        const open = document.body.classList.contains('cart-sidebar-show');
        if (open === cartOpen) return;
        cartOpen = open;
        if (open) {
            const active = document.activeElement;
            cartOpener = active && active !== document.body && !drawer.contains(active) ? active : lastControl;
            drawer.inert = false;
            drawer.setAttribute('aria-hidden', 'false');
            drawer.setAttribute('aria-modal', 'true');
            focusDrawer();
            requestAnimationFrame(() => {
                if (cartOpen && !drawer.contains(document.activeElement)) focusDrawer();
            });
        } else {
            drawer.removeAttribute('aria-modal');
            drawer.setAttribute('aria-hidden', 'true');
            drawer.inert = true;
            const target = visible(cartOpener) ? cartOpener : [...document.querySelectorAll('[data-cart-sidebar]')].find(visible);
            if (target && !externalPopup()) target.focus({preventScroll: true});
            cartOpener = null;
        }
    }
    if (drawer) {
        drawer.addEventListener('transitionend', event => {
            if (event.target === drawer && cartOpen && !drawer.contains(document.activeElement)) focusDrawer();
        });
        drawer.inert = !document.body.classList.contains('cart-sidebar-show');
        drawer.setAttribute('aria-hidden', String(drawer.inert));
        new MutationObserver(() => {
            if (cartOpen && document.activeElement === document.body) focusDrawer();
        }).observe(drawer, {childList: true, subtree: true});
    }
    new MutationObserver(syncBody).observe(document.body, {attributes: true, attributeFilter: ['class']});
    syncBody();
    document.addEventListener('focusin', event => {
        const sidebar = event.target.closest('.page-sidebar');
        if (sidebar) initializeFilters(sidebar);
        if (cartOpen && drawer && !drawer.contains(event.target) && !externalPopup()) focusDrawer();
    });
    document.addEventListener('keydown', event => {
        if (sidebarOpen && event.key === 'Escape' && !event.defaultPrevented && !cartOpen) {
            const sidebar = document.getElementById('halo-sidebar');
            if (sidebar?.contains(event.target)) {
                event.preventDefault();
                const slide = event.target.closest('.sidebarBlock-slide__content.is-show');
                (slide?.querySelector('.sidebarBlock-slide__content-close') || sidebar.querySelector('[data-close-sidebar]'))?.click();
            }
        }
        if (!cartOpen || !drawer || event.defaultPrevented || externalPopup()) return;
        const popup = drawer.querySelector('.popup-toolDown.show');
        const region = popup || drawer;
        if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            if (popup) {
                popup.querySelector('cart-cancel-popup button')?.click();
                if (visible(toolOpener) && toolOpener.matches(focusSelector)) toolOpener.focus();
                else focusDrawer();
            } else drawer.querySelector('[data-close-cart-sidebar]')?.click();
        } else if (event.key === 'Tab') {
            const controls = focusables(region);
            const first = controls[0] || drawer;
            const last = controls[controls.length - 1] || drawer;
            if (!controls.length || (event.shiftKey && (document.activeElement === first || !region.contains(document.activeElement))) || (!event.shiftKey && (document.activeElement === last || !region.contains(document.activeElement)))) {
                event.preventDefault();
                (event.shiftKey ? last : first).focus();
            }
        }
    });
})();
